<template>
  <div>
    <h1>{{ $t("delegationTask.title") }}</h1>
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <delegation-task-form @saved="load">
          <v-btn block color="accent">{{ $t("delegationTask.newDelegationTask") }} </v-btn>
        </delegation-task-form>
      </div>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="delegationTask"
      :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
      :search="search"
      hide-default-footer
    >
      <template #item="props">
        <tr>
          <td class="text-left">
            <v-tooltip bottom>
              {{ $t("global.moveUp") }}
              <template #activator="{on}">
                <v-btn :disabled="props.item.list_order === 1" @click="moveUp(props.item)" icon v-on="on">
                  <v-icon>fa-arrow-alt-circle-up</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            {{ props.item.list_order }}
            <v-tooltip bottom>
              {{ $t("global.moveDown") }}
              <template #activator="{on}">
                <v-btn :disabled="props.item.list_order === delegationTask.length" @click="moveDown(props.item)" icon v-on="on">
                  <v-icon>fa-arrow-alt-circle-down</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
          <td class="text-left">
            {{ getName(props.item) }}
          </td>
          <td class="text-left">
            <span v-if="props.item.is_comment_required === 1">{{ $t("global.yes") }}</span>
            <span v-if="props.item.is_comment_required === 0">{{ $t("global.no") }}</span>
          </td>
          <td class="text-left">
            <span v-if="props.item.is_enabled === 1">{{ $t("global.yes") }}</span>
            <span v-if="props.item.is_enabled === 0">{{ $t("global.no") }}</span>
          </td>
          <td class=" justify-center align-content-center px-0">
            <span v-if="props.item.used_in_delegations > 0"
              >{{ $t("delegationTask.taskEditAppliesNTimes", props.item.used_in_delegations, { count: props.item.used_in_delegations }) }} <br
            /></span>
            <span v-if="props.item.used_in_delegations === 0">{{ $t("delegationTask.taskZeroTimes") }}<br /></span>
            <span v-if="props.item.is_system_value > 0">{{ $t("delegationTask.systemItem") }}</span>
          </td>
          <td class="text-no-wrap text-center">
            <delegation-task-form :delegation-task.sync="props.item" @saved="load"></delegation-task-form>
            <v-tooltip bottom>
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn @click="removeDelegationTask(props.item)" icon v-on="on" v-if="!props.item.is_system_value && props.item.used_in_delegations === 0">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DelegationTaskForm from "../../components/Settings/DelegationTaskForm";

export default {
  name: "SettingsDelegationTaskView",
  components: { DelegationTaskForm },
  data: () => ({
    delegationTask: [],
    search: ""
  }),
  created() {
    this.load();
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("delegationTask.headers.ordinate"),
          value: "list_order",
          sortable: true
        },
        { text: this.$t("delegationTask.headers.name"), value: "name" },
        {
          text: this.$t("delegationTask.headers.isCommentRequired"),
          value: "is_comment_required",
          sortable: false
        },
        {
          text: this.$t("delegationTask.headers.isEnabled"),
          value: "is_enabled",
          sortable: false
        },
        { text: " ", value: "actions2", sortable: false },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    },
    hasPermissionForEdit() {
      return this.$store.getters.hasPermission("SuperAdmin") || this.$store.getters.hasPermission("companyAdmin");
    }
  },
  methods: {
    getName(item) {
      if (this.$i18n.locale === "pl") return item.name;
      if (item.name_en == null || item.name_en.length < 1) return item.name;
      return item.name_en;
    },
    load() {
      this.axios.get("delegation-task/list").then(response => {
        this.delegationTask = response.data;
      });
    },
    removeDelegationTask(item) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.removeConfirm.content"),
        title: this.$t("global.removeConfirm.title")
      });
      result.then(() => {
        this.axios.post("delegation-task/delete", { id: item.id }).then(() => {
          this.load();
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.deleted")
          });
        });
      });
    },
    moveUp(item) {
      this.axios.post("delegation-task/move-up", { id: item.id }).then(() => {
        this.load();
      });
    },
    moveDown(item) {
      this.axios.post("delegation-task/move-down", { id: item.id }).then(() => {
        this.load();
      });
    }
  }
};
</script>

<style scoped></style>
